document.addEventListener('DOMContentLoaded', () => {
    const sliders = document.querySelectorAll<HTMLElement>('.sbs-testimonial-slider');

    sliders.forEach((slider) => {
        const track = slider.querySelector<HTMLElement>('.sbs-testimonial-slider__track');
        const slides = slider.querySelectorAll<HTMLElement>('.sbs-testimonial-slider__slide');
        const prevBtn = slider.querySelector<HTMLElement>('.sbs-testimonial-slider__arrow--prev');
        const nextBtn = slider.querySelector<HTMLElement>('.sbs-testimonial-slider__arrow--next');
        const counterCurrent = slider.querySelector<HTMLElement>('.sbs-testimonial-slider__counter-current');

        if (!track || slides.length === 0) return;

        const total = slides.length;
        const ease = 'transform 0.4s cubic-bezier(.56, .15, .16, 1)';
        const DISTANCE_THRESHOLD = 50;
        const VELOCITY_THRESHOLD = 0.5;

        let activeIndex = 0;
        let isDragging = false;
        let startX = 0;
        let startTime = 0;
        let deltaX = 0;
        let trackWidth = 0;
        let activePointerId: number | null = null;

        track.style.transition = ease;

        const setTransform = (offsetPx: number = 0) => {
            track.style.transform = `translateX(calc(${-activeIndex * 100}% + ${offsetPx}px))`;
        };

        const updateCounter = () => {
            if (counterCurrent) {
                counterCurrent.textContent = String(activeIndex + 1);
            }
            slider.setAttribute('data-active', String(activeIndex));
        };

        const goTo = (index: number) => {
            activeIndex = ((index % total) + total) % total;
            track.style.transition = ease;
            setTransform(0);
            updateCounter();
        };

        const goPrev = () => goTo(activeIndex - 1);
        const goNext = () => goTo(activeIndex + 1);

        if (prevBtn) prevBtn.addEventListener('click', goPrev);
        if (nextBtn) nextBtn.addEventListener('click', goNext);

        const onPointerDown = (e: PointerEvent) => {
            if (e.pointerType === 'mouse' && e.button !== 0) return;
            if (total < 2) return;

            isDragging = true;
            activePointerId = e.pointerId;
            startX = e.clientX;
            startTime = performance.now();
            deltaX = 0;
            trackWidth = track.getBoundingClientRect().width;
            track.style.transition = 'none';
            try { track.setPointerCapture(e.pointerId); } catch (_) {}
        };

        const onPointerMove = (e: PointerEvent) => {
            if (!isDragging || e.pointerId !== activePointerId) return;
            deltaX = e.clientX - startX;
            setTransform(deltaX);
        };

        const finishDrag = (e: PointerEvent) => {
            if (!isDragging || e.pointerId !== activePointerId) return;

            const elapsed = Math.max(performance.now() - startTime, 1);
            const velocity = Math.abs(deltaX) / elapsed;

            track.style.transition = ease;

            const passedDistance = Math.abs(deltaX) >= DISTANCE_THRESHOLD;
            const passedVelocity = velocity >= VELOCITY_THRESHOLD && Math.abs(deltaX) > 10;

            if (passedDistance || passedVelocity) {
                if (deltaX < 0) {
                    goNext();
                } else {
                    goPrev();
                }
            } else {
                setTransform(0);
            }

            try { track.releasePointerCapture(e.pointerId); } catch (_) {}
            isDragging = false;
            activePointerId = null;
            deltaX = 0;
        };

        track.addEventListener('pointerdown', onPointerDown);
        track.addEventListener('pointermove', onPointerMove);
        track.addEventListener('pointerup', finishDrag);
        track.addEventListener('pointercancel', finishDrag);

        track.addEventListener('dragstart', (e) => e.preventDefault());

        updateCounter();
        setTransform(0);
    });
});
